export interface MyDraegerRight {
  id: string;
  name: string;
  description: string;
}

export const MYDRAEGER_RIGHTS: MyDraegerRight[] = [
  {
    id: "N000",
    name: "FGDS",
    description: "Business Scope FGDS",
  },
  {
    id: "N001",
    name: "Monitoring",
    description: "Business Scope Monitoring",
  },
  {
    id: "N002",
    name: "FGDS-GlobalAdmin-Role-Write",
    description: "Allow to add and remove GlobalAdmin Role within FGDS Scope",
  },
  {
    id: "N003",
    name: "FGDS-CountryKeyAccountManager-Role-Write",
    description: "Allow to add and remove CountryKeyAccountManager_<country> Role within FGDS Scope",
  },
  {
    id: "N004",
    name: "FGDS-User-Role-Write",
    description: "Allow to add and remove FGDS-User Role",
  },
  {
    id: "N005",
    name: "Monitoring-GlobalAdmin-Role-Write",
    description: "Allow to add and remove GlobalAdmin Role within Monitoring Scope",
  },
  {
    id: "N006",
    name: "Monitoring-CountryKeyAccountManager-Role-Write",
    description: "Allow to add and remove CountryKeyAccountManager_<country> Role within Monitoring Scope",
  },
  {
    id: "N007",
    name: "Monitoring-User-Role-Write",
    description: "Allow to add and remove User Role within Monitoring scope",
  },
  {
    id: "N008",
    name: "Global Admin",
    description:
      "Write access to all projects in business scope; Right to assign roles Country Key Account Manager [Country Key] and Internal User in all countries",
  },
  {
    id: "N009",
    name: "User",
    description: "Write access to own and collaboration projects; Read access to all projects",
  },
  {
    id: "N010",
    name: "CountryKeyAccountManager_DE",
    description: "Write Access for all projects in DE",
  },
  {
    id: "N011",
    name: "CountryKeyAccountManager_AT",
    description: "Write Access for all projects in AT",
  },
  {
    id: "N012",
    name: "CountryKeyAccountManager_CH",
    description: "Write Access for all projects in CH",
  },
  {
    id: "N013",
    name: "CountryKeyAccountManager_IN",
    description: "Write Access for all projects in IN",
  },
  {
    id: "N014",
    name: "CountryKeyAccountManager_AU",
    description: "Write Access for all projects in AU",
  },
  {
    id: "N015",
    name: "CountryKeyAccountManager_FI",
    description: "Write Access for all projects in FI",
  },
  {
    id: "N016",
    name: "CountryKeyAccountManager_DK",
    description: "Write Access for all projects in DK",
  },
  {
    id: "N017",
    name: "CountryKeyAccountManager_SE",
    description: "Write Access for all projects in SE",
  },
  {
    id: "N018",
    name: "CountryKeyAccountManager_NO",
    description: "Write Access for all projects in NO",
  },
  {
    id: "N019",
    name: "CountryKeyAccountManager_BE",
    description: "Write Access for all projects in BE",
  },
  {
    id: "N020",
    name: "CountryKeyAccountManager_US",
    description: "Write Access for all projects in US",
  },
  {
    id: "N021",
    name: "CountryKeyAccountManager_FR",
    description: "Write Access for all projects in FR",
  },
  {
    id: "N022",
    name: "CountryKeyAccountManager_MX",
    description: "Write Access for all projects in MX",
  },
  {
    id: "N023",
    name: "CountryKeyAccountManager_MY",
    description: "Write Access for all projects in MY",
  },
  {
    id: "N024",
    name: "CountryKeyAccountManager_BR",
    description: "Write Access for all projects in BR",
  },
  {
    id: "N025",
    name: "CountryKeyAccountManager_TEST",
    description: "Write Access for all projects in TEST",
  },
  {
    id: "N026",
    name: "CountryKeyAccountManager_NZ",
    description: "Write Access for all projects in NZ",
  },
  {
    id: "N027",
    name: "Assign-Any-Navinta-Role-Write",
    description: "Write Access for all projects in NZ",
  },
];
